import React, { useState, useEffect } from 'react';
import Snowfall from './Snowfall';
import ChristmasDecorations from './ChristmasDecorations';

const ChristmasTheme = () => {
  const [isChristmasSeason, setIsChristmasSeason] = useState(false);

  useEffect(() => {
    const checkChristmasSeason = () => {
      const now = new Date();
      const year = now.getFullYear();

      // Christmas season: December 1st to December 26th
      const seasonStart = new Date(year, 10, 1); // Month is 0-indexed, so 11 = December
      const seasonEnd = new Date(year, 11, 27); // December 27th 00:00 (so 26th is included)

      setIsChristmasSeason(now >= seasonStart && now < seasonEnd);
    };

    checkChristmasSeason();

    // Check daily in case the page is left open
    const interval = setInterval(checkChristmasSeason, 1000 * 60 * 60); // Check every hour

    return () => clearInterval(interval);
  }, []);

  if (!isChristmasSeason) {
    return null;
  }

  return (
    <>
      <Snowfall />
      <ChristmasDecorations />
    </>
  );
};

export default ChristmasTheme;
